import { Row, Col } from "react-bootstrap";

import classes from "../Inventory/inventory.module.scss";
import ButtonFilter from "@/components/Filter/ButtonFilter";

const EmptyContainerFunctions = ({ showFilter, setShowFilter, _permissions }) => {
	return (
		<Row className={classes.header}>
			<ButtonFilter origin="actions" size_md={1} showFilter={showFilter} setShowFilter={setShowFilter} />

			<Col md={11} sm={12} xs={12} className={classes.functionColBase}></Col>
		</Row>
	);
};

export default EmptyContainerFunctions;
